let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("ffEVr"), load("kDPsc"), load("jUe3X")]).then(() => parcelRequire('jvsYc'));